import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Paper,
  Modal,
  Typography,
  Box,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BookmarkIcon from "../../../assets/icons/BookmarkIcon";
import DeleteIcon from "../../../assets/icons/DeleteIcon";
import Checkbox from "../../../common/Checkbox";
import CloseIcon from "@mui/icons-material/Close";
import { SecondaryButton } from "../../../common/Buttons";
import { Container } from "@mui/system";

import "./index.scss";
import { getUploadedDoc, putDocument } from "../../../services/yourWishes";
import { Circles } from "react-loader-spinner";
import { useTranslation } from "react-i18next";
import { getKeyFromText } from "../../../utils/Utilities";
import Pagination from "../../../common/Pagination";

const DocumentsFiles = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  let navigate = useNavigate();
  const [list, setList] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [filterByMarked, setFilterByMarked] = useState(false);
  const [filterByDelete, setFilterByDelete] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [meta, setMeta] = useState({
    pageSize: 6,
    pageNumber: 1,
    sortOrder: "asc",
    itemsCount: 6,
  });
  const handleRefresh = () => {
    setRefresh((pre) => !pre);
  };
  const handleChangeCheck = (e) => {
    setList(
      list.map((item) => {
        if (item.statusQuoMediaId == e.target.id)
          return { ...item, isChecked: !item.isChecked };
        return item;
      })
    );
  };
  const handleClickName = () => {
    navigate("/cases/111/family-tree");
  };
  const NameBookmark = async (ele) => {
    setList(
      list.map((item) => {
        if (item.statusQuoMediaId == ele.statusQuoMediaId)
          return { ...item, isMarkedByAdvisor: !item.isMarkedByAdvisor };
        return item;
      })
    );
    const result = await putDocument(
      [{ ...ele, isMarkedByAdvisor: !ele.isMarkedByAdvisor }],
      id
    );
    if (result?.success) {
      handleRefresh();
    }
  };
  const handleDelete = async () => {
    const result = await putDocument(
      list
        .filter((item) => item.isChecked)
        .map((ele) => ({ ...ele, isDeletedByAdvisor: true })),
      id
    );
    if (result?.success) {
      handleRefresh();
    }
  };
  const fetchData = async () => {
    setLoading(true);
    try {
      const result = await getUploadedDoc(id, { ...meta });
      if (result?.success) {
        let data = [];
        if (!filterByDelete && !filterByMarked) {
          data = result?.payLoad.items.map(
            (item) => ({ ...item, isChecked: false } || [])
          );
        } else if (filterByDelete && !filterByMarked) {
          data =
            result?.payLoad.items
              .map((item) => ({ ...item, isChecked: false }))
              .filter((ele) => ele.isDeletedByAdvisor) || [];
        } else if (!filterByDelete && filterByMarked) {
          data =
            result?.payLoad.items
              .map((item) => ({ ...item, isChecked: false }))
              .filter((ele) => ele.isMarkedByAdvisor) || [];
        } else {
          data =
            result?.payLoad.items
              .map((item) => ({ ...item, isChecked: false }))
              .filter(
                (ele) => ele.isMarkedByAdvisor || ele.isDeletedByAdvisor
              ) || [];
        }
        setList(data || []);
        setMeta({
          ...meta,
          pageNumber: result?.payLoad?.currentPage || 1,
          itemsCount: result?.payLoad?.totalCount || data.length,
        });
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
    setDeleteModal(false);
  }, [refresh, filterByDelete, filterByMarked]);

  const handleChangePage = (item) => {
    setMeta({ ...meta, pageNumber: item });
    handleRefresh();
  };
  const handleClose = () => {
    setDeleteModal(false);
  };
  return (
    <>
      <div
        className="summary-table"
        style={{
          minHeight: "500px",
          overflow: "auto",
          display: loading ? "flex" : "block",
          justifyContent: "center",
          alignItems: loading && "center",
        }}
      >
        {loading ? (
          <Circles color="#dfc8db" height={80} width={80} />
        ) : (
          <>
            <TableContainer component={Paper}>
              <Table
                sx={{ minWidth: 650, maxHeight: "300px", overflow: "auto" }}
                aria-label="simple table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ width: "15px" }}>
                      <Box sx={{ display: "flex" }}>
                        <DeleteIcon
                          type={"filled"}
                          style={{
                            margin: "auto 0",
                            width: "20px",
                            fill: "black",
                            pointerEvents: list?.every(
                              (item) => !item?.isChecked
                            )
                              ? "none"
                              : "all",
                            cursor: list?.every((item) => !item?.isChecked)
                              ? "default"
                              : "pointer",
                            opacity: list?.every((item) => !item?.isChecked)
                              ? 0.6
                              : 1,
                          }}
                          onClick={() => setDeleteModal(true)}
                        />
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: "flex" }}>
                        <Box
                          component="div"
                          sx={{
                            display: "flex",
                            justifyCotent: "center",
                            alignItems: "center",
                            fontWeight: "400",
                            marginRight: "30px",
                            cursor: "pointer",
                            opacity: filterByMarked ? 1 : 0.6,
                          }}
                          onClick={() => {
                            setFilterByMarked((pre) => !pre);
                          }}
                        >
                          <BookmarkIcon
                            style={{
                              width: "20px",
                              display: "flex",
                              alignItems: "center",
                              fill: filterByMarked ? "#FFD76C" : "none",
                              cursor: "pointer",
                            }}
                            color={filterByMarked ? "#FFD76C" : "#A3A3A3"}
                          />

                          {t(getKeyFromText("Marked documents"))}
                        </Box>
                        <Box
                          component="div"
                          sx={{
                            display: "flex",
                            justifyCotent: "center",
                            alignItems: "center",
                            fontWeight: "400",
                            cursor: "pointer",
                            opacity: filterByDelete ? 1 : 0.6,
                          }}
                          onClick={() => {
                            setFilterByDelete((pre) => !pre);
                          }}
                        >
                          <DeleteIcon
                            type={"filled"}
                            style={{
                              width: "20px",
                              fill: "black",
                              cursor: "pointer",
                            }}
                          />
                          {t(getKeyFromText("Deleted documents"))}
                        </Box>
                      </Box>
                    </TableCell>

                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {list.map((item) => {
                    return (
                      <TableRow key={item.id}>
                        <TableCell component="th" scope="row">
                          <div
                            style={{
                              marginTop: "-8px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Checkbox
                              id={item?.statusQuoMediaId}
                              checked={item.isChecked}
                              onChange={handleChangeCheck}
                            />
                          </div>
                        </TableCell>
                        <TableCell>
                          <Box
                            sx={{
                              display: "flex",
                              justifyCotent: "center",
                              alignItems: "center",
                              fontWeight: "400",
                            }}
                          >
                            <BookmarkIcon
                              style={{
                                width: "20px",
                                display: "flex",
                                alignItems: "center",
                                fill: item.isMarkedByAdvisor
                                  ? "#FFD76C"
                                  : "none",
                                cursor: "pointer",
                              }}
                              color={
                                item.isMarkedByAdvisor ? "#FFD76C" : "#A3A3A3"
                              }
                              onClick={() => {
                                NameBookmark(item);
                              }}
                            />
                            {item?.originalFilename}
                          </Box>
                        </TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
              <Pagination
                itemsCount={meta.itemsCount}
                pageSize={meta.pageSize}
                currentPage={meta.pageNumber}
                onPageChange={handleChangePage}
              />
            </TableContainer>
            {deleteModal && (
              <Modal
                keepMounted
                open={true}
                onClose={handleClose}
                aria-labelledby="keep-mounted-modal-title"
                aria-describedby="keep-mounted-modal-description"
              >
                <Container maxWidth="xs">
                  <Box
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      maxWidth: 400,
                      bgcolor: "background.paper",
                      borderRadius: "15px",
                      boxShadow: 24,
                      p: 4,
                      textAlign: "center",
                      padding: "20px 20px",
                      minWidth: 300,
                    }}
                  >
                    <Typography sx={{ textAlign: "right", cursor: "pointer" }}>
                      <CloseIcon onClick={handleClose} />
                    </Typography>
                    <Typography>
                      <DeleteIcon
                        style={{
                          width: "35px",
                          margin: "10px",
                        }}
                      />
                    </Typography>
                    <Typography
                      id="keep-mounted-modal-title"
                      variant="h6"
                      component="h2"
                    >
                      {t("are-you-sure-you-want-to-delete-this-case")}
                    </Typography>

                    <Typography sx={{ mt: 3 }}>
                      <SecondaryButton
                        title={t("yes")}
                        textTransform="initial"
                        width={false}
                        padding="0.25rem 3rem"
                        border="2px solid #C498BB40"
                        borderRadius={2}
                        fontSize="0.85rem"
                        fontWeight="500"
                        marginTop="4px"
                        click={handleDelete}
                      />
                    </Typography>
                  </Box>
                </Container>
              </Modal>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default DocumentsFiles;
